export type ChartValueTick = {
  value: number;
  position: number;
};

export type ChartValueScale = {
  minimum: number;
  maximum: number;
  ticks: ChartValueTick[];
};

function niceStep(value: number) {
  const exponent = Math.floor(Math.log10(value));
  const magnitude = 10 ** exponent;
  const fraction = value / magnitude;
  const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 2.5 ? 2.5 : fraction <= 5 ? 5 : 10;
  return niceFraction * magnitude;
}

export function chartValueScale(minimum: number, maximum: number, divisions = 4, integersOnly = false): ChartValueScale {
  let lower = Number.isFinite(minimum) ? minimum : 0;
  let upper = Number.isFinite(maximum) ? maximum : 1;
  if (lower >= 0) lower = 0;
  if (upper <= 0) upper = 0;
  if (lower === upper) upper = lower === 0 ? 1 : lower + Math.max(1, Math.abs(lower) * 0.1);

  const safeDivisions = Math.max(1, Math.floor(divisions));
  let step = niceStep((upper - lower) / safeDivisions);
  if (integersOnly) step = Math.max(1, Math.ceil(step));
  const niceMinimum = Math.floor(lower / step) * step;
  const niceMaximum = Math.ceil(upper / step) * step;
  const count = Math.round((niceMaximum - niceMinimum) / step);
  const ticks = Array.from({ length: count + 1 }, (_, index) => ({
    value: Number((niceMinimum + index * step).toPrecision(12)),
    position: index / Math.max(1, count),
  }));
  return { minimum: niceMinimum, maximum: niceMaximum, ticks };
}
